<div class="chart-panel">
    <div #chart></div>
</div>
